/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseClient } from '../base-client';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getInfo } from '../fn/info/get-info';
import { GetInfo$Params } from '../fn/info/get-info';
import { ServerInfoDto as PlatformServerInfoDto } from '../models/platform/server-info-dto';

@Injectable({ providedIn: 'root' })
export class InfoClient extends BaseClient {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `infoGetInfo()` */
  static readonly InfoGetInfoPath = '/info';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInfo$Response(context?: HttpContext): Observable<StrictHttpResponse<PlatformServerInfoDto>> {
    const obs = getInfo(this.http, this.rootUrl, {} satisfies GetInfo$Params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getInfo(context?: HttpContext): Observable<PlatformServerInfoDto> {
    const resp = this.getInfo$Response(context);
    return resp.pipe(
      map((r: StrictHttpResponse<PlatformServerInfoDto>): PlatformServerInfoDto => r.body)
    );
  }

}
